import React, {useContext, useEffect, useState} from "react";
import {useCountDown} from "ahooks";
import cx from 'classnames';
import moment from "moment";
import {Button, Col, Row, Space} from "antd";
import {useRouter} from "next/router";
import {useSelector} from "react-redux";
import {FcrpdPaperStatus, PlanStatus, TExamKind} from "@/types";
import {calcExamTitle, judgeIsPExam} from "@/utils";
import PCSignupBtn from "@/page-components/detail/Intro/pc_signup_btn";
import SignupInfoCountdown from "@/page-components/detail/Intro/signup_info_coutdown";
import {TExamPlanItem} from "@/page-components/detail/Intro/exam_plan";
import {DetailContext} from "@/context/detailContext";
import {TUserInfoTypes} from "@/types/redux_type";
import UnRealNameWarningModal from "@/components/UnRealNameWarningModal/index";
import styles from './styles.module.less';

const Gap: React.FC<{ gap: number }> = ({children, gap}) => {
  return <div style={{marginBottom: gap}}>{children}</div>
}

type TSignupInfo = {
  type: TExamKind;
  data: TExamPlanItem;
  allData: TExamPlanItem[];
}

const SignupInfo: React.FC<TSignupInfo> = (
  {
    allData,
    type,
    data,
  }) => {
  const userInfo = useSelector<{ userInfo: TUserInfoTypes }, TUserInfoTypes>(state => state.userInfo);
  const contextProps = useContext(DetailContext);
  const {data: staticExamInfo, userInfo: {isOrganizationAdmin}} = contextProps;
  const {
    exam_info: {
      pass_link,
      pass_tips,
      no_pass_link,
      no_pass_tips,
      fcrpd_text,
    }
  } = staticExamInfo;

  const [signupInfoData, setSignInfoData] = useState<TExamPlanItem>({
    examId: "", examName: "", paperId: "", payState: 0,
    certScoreLine: 0, newPaperState: 0,
    appeal_time: 0,
    certName: "",
    duration: "",
    endTime: 0,
    fullScore: 0,
    id: 0,
    publishTime: 0,
    couponValidity: null,
    score: 0,
    scoreLine: 0,
    startTime: 0,
    state: 0,
    paperState: 0,
    submit_time: 0,
    examExpiresTime: null
  });
  const [fcrpdPass, setFcrpdPass] = useState(false);
  // const mockData = [
  //   {paperState: FcrpdPaperStatus.pass},
  //   {paperState: FcrpdPaperStatus.pass},
  //   {paperState: FcrpdPaperStatus.pass},
  //   {paperState: FcrpdPaperStatus.noPass}
  // ]

  useCountDown({
    targetDate: data.startTime,
    onEnd: () => {
      if (signupInfoData.state === PlanStatus.noStart) {
        const endTime = moment(data.startTime).add(data.duration, 'm');
        const newState = PlanStatus.examing;
        // 考试已经结束了;
        // if (moment().isAfter(endTime)){
        //   newState = PlanStatus.reviewing;
        // }
        setSignInfoData(prevState => {
          return {...prevState, state: newState}
        });
      }
    }
  });
  const router = useRouter();
  const renderIcon = (status: PlanStatus) => {
    switch (status) {
      case PlanStatus.finished:
      case PlanStatus.noStart:
        return '/img/detail/plan/no_start_big.png';
      case PlanStatus.examing:
        return '/img/detail/plan/examing_big.png';
      case PlanStatus.pass:
        return '/img/detail/plan/pass_big.png';
      case PlanStatus.noPass:
        return '/img/detail/plan/nopass_big.png';
      case PlanStatus.reviewing:
        return '/img/detail/plan/reviewing.png';
      case PlanStatus.appealing:
        return '/img/detail/plan/appealing.png';
      default:
        return '/img/detail/plan/examing_big.png';
    }
  }
  const calcEndTime = () => {
    if (data.schId) {
      return moment(data.endTime)
    }
    return moment(data.startTime).add(data.duration, 'm')
  }
  const renderUnrealnameBtn = () => {
    if (!userInfo.isPassRealnameAuthentication) {
      return (
        <UnRealNameWarningModal>
          <div className={styles.signup_info_wrapper_body_unrealname_wrapper}>
            <div className={styles.unrealname_text}>认证考试仅对实名用户开放，未认证将无法考试</div>
            <Button type="primary" className={styles.unrealname_btn}>去实名认证</Button>
          </div>
        </UnRealNameWarningModal>
      )
    }
    return null;
  }
  // 渲染admin报名p系列的按钮
  const isAdminJoinExamBtn = () => {
    return judgeIsPExam(type) && isOrganizationAdmin;

  }
  const renderItem = (status: PlanStatus) => {
    switch (status) {
      case PlanStatus.noStart:
        return (
          <>
            <p className={styles.signup_info_wrapper_body_text}>已成功报名</p>
            <p
              className={cx(styles.signup_info_wrapper_body_text, styles.gap)}>{data.certName && `第${data.certName}期`} {calcExamTitle(type)}</p>
            {data.startTime && data.duration && (
              <p
                className={styles.signup_info_wrapper_body_time_text}>考试时间{moment(data.startTime).format('YYYY-MM-DD HH:mm:ss')}至{calcEndTime().format('YYYY-MM-DD HH:mm:ss')}</p>
            )}
            {renderUnrealnameBtn()}
            {isOrganizationAdmin && <PCSignupBtn passExam wrapperStyle={{marginTop: 10}}/>}
          </>
        )
      case PlanStatus.examing:
        return (
          <>
            <p className={styles.signup_info_wrapper_body_text}>考试进行中</p>
            <Gap gap={12}>
              <div
                className={cx(styles.signup_info_wrapper_body_text)}>{data.certName && `第${data.certName}期`} {calcExamTitle(type)}</div>
            </Gap>
            {data.startTime && data.duration && (
              <p
                className={styles.signup_info_wrapper_body_time_text}>考试时间{moment(data.startTime).format('YYYY-MM-DD HH:mm:ss')}至{calcEndTime().format('YYYY-MM-DD HH:mm:ss')}</p>
            )}
            {renderUnrealnameBtn()}
            {isAdminJoinExamBtn() && <PCSignupBtn wrapperStyle={{marginTop: 10}} passExam/>}
          </>
        )
      case PlanStatus.pass:
        return (
          <>
            <Gap gap={8}>
              <p className={styles.signup_info_wrapper_body_text}>{pass_tips}</p>
            </Gap>
            {pass_link && (
              <Gap gap={16}>
                <Space className={cx(styles.signup_info_wrapper_body_time_text, styles.gap)}>
                  <p dangerouslySetInnerHTML={{__html: pass_link}}/>
                </Space>
              </Gap>
            )}
            <Space>
              {judgeIsPExam(type) && isOrganizationAdmin && (
                <PCSignupBtn passExam/>
              )}
              <Button style={{marginLeft: 0}} className={styles.simple_btn} onClick={() => {
                router.push('/verify');
              }}>证书&成绩查询</Button>
            </Space>
          </>
        )
      case PlanStatus.noPass:
        return (
          <>
            <Gap gap={8}>
              <p className={styles.signup_info_wrapper_body_text} dangerouslySetInnerHTML={{__html: no_pass_tips}}/>
            </Gap>
            {data.couponValidity && (
              <Gap gap={8}>
                <p
                  className={cx(styles.signup_info_wrapper_body_time_text)}>补考优惠券已发放，{moment(data.couponValidity).format('YYYY-MM-DD HH:mm:ss')}前可免费报名</p>
              </Gap>
            )}
            <Gap gap={16}>
              {no_pass_link && (
                <p style={{textAlign: 'center'}} dangerouslySetInnerHTML={{__html: no_pass_link}}/>
              )}
            </Gap>
            <Row gutter={16}>
              <Col span={12}>
                <PCSignupBtn
                  noPass
                />
              </Col>
              <Col span={12}>
                <Button onClick={() => {
                  router.push('/verify')
                }}>证书&成绩查询</Button>
              </Col>
            </Row>
          </>
        )
      case PlanStatus.reviewing:
        return (
          <>
            <p className={styles.signup_info_wrapper_body_text}>已交卷</p>
            <p
              className={cx(styles.signup_info_wrapper_body_text, styles.gap)}>{data.certName && `第${data.certName}期`} {calcExamTitle(type)}</p>
            <p className={styles.signup_info_wrapper_body_time_text}>阅卷中，预计14个工作日出成绩</p>
            {isOrganizationAdmin && <PCSignupBtn wrapperStyle={{marginTop: 10}} passExam/>}
          </>
        )
      case PlanStatus.finished:
        return (
          <>
            <p className={styles.signup_info_wrapper_body_text}>考试已结束</p>
            {isOrganizationAdmin && <PCSignupBtn wrapperStyle={{marginTop: 10}} passExam/>}
          </>
        )
      default:
        return null;
    }
  }
  useEffect(() => {
    setSignInfoData(data);
  }, [data]);
  const calcNewStateInFcrpd = (item: TExamPlanItem, paperState?: FcrpdPaperStatus) => {
    if (paperState !== undefined) {
      switch (paperState) {
        // @ts-ignore
        case FcrpdPaperStatus.noStart:
          return PlanStatus.noStart;
        case FcrpdPaperStatus.examing:
          return PlanStatus.examing;
        case FcrpdPaperStatus.noSubmitPaper:
          return PlanStatus.examing;
        case FcrpdPaperStatus.todoreview:
          return PlanStatus.reviewing;
        case FcrpdPaperStatus.reviewing:
          return PlanStatus.reviewing;
        case FcrpdPaperStatus.todoPublish:
          return PlanStatus.reviewing;
        case FcrpdPaperStatus.pass:
          return PlanStatus.pass;
        case FcrpdPaperStatus.noPass:
          return PlanStatus.noPass;
        case FcrpdPaperStatus.noPassNoAnswer:
          return PlanStatus.noPass;
        case FcrpdPaperStatus.appealing:
          return PlanStatus.appealing;
        default:
          return PlanStatus.noStart;
      }
    }
    return PlanStatus.finished;
  }

  const calcPaperState = (item: TExamPlanItem, paperState?: FcrpdPaperStatus) => {
    const endTime = calcEndTime();
    const startTime = moment(item.startTime);
    const inExam = moment().isAfter(startTime) && moment().isBefore(endTime);
    // 考试已经结束了;
    // const isEnd = moment().isAfter(endTime);
    if (fcrpdPass) {
      return PlanStatus.pass
    }
    for (const exam of allData) {
      exam.newPaperState = calcNewStateInFcrpd(exam, exam.paperState);
    }
    const allFinish = allData.filter(allDataItem => allDataItem.newPaperState === PlanStatus.pass || allDataItem.newPaperState === PlanStatus.noPass);// 已经交卷的
    const isFailArray = allData.filter(allDataItem => allDataItem.newPaperState === PlanStatus.noPass);// 没通过的
    const isReviewArray = allData.filter(allDataItem => allDataItem.newPaperState === PlanStatus.reviewing);
    if (isFailArray.length > 0) {
      return PlanStatus.noPass;
    }
    if (inExam) {
      if (isReviewArray.length === allData.length) {
        return PlanStatus.reviewing;
      }
      if (allFinish.length === allData.length) {
        return fcrpdPass ? PlanStatus.pass : PlanStatus.noPass;
      }
      return PlanStatus.examing;
    }
    if (isReviewArray.length > 0) {
      return PlanStatus.reviewing;
    }
    if (allFinish.length === allData.length) {
      return fcrpdPass ? PlanStatus.pass : PlanStatus.noPass;
    }
    return PlanStatus.noStart;
  }

  // 计算fcrpd过了么 用户得分大于等于总分并且每门都过了才算通过
  const calcFCRPDPass = () => {
    if (allData.length > 0) {
      let isPass = true;
      let score = 0;
      const totalScoreLine = allData[0].certScoreLine || 0; // 总分
      for (const exam of allData) {
        if (calcNewStateInFcrpd(exam, exam.paperState) !== PlanStatus.pass) {
          isPass = false;
          break;
        }
        if (exam.score) {
          score += Number(exam.score);
        }
      }
      if (score < totalScoreLine) {
        isPass = false;
      }
      setFcrpdPass(isPass);
    }
  }
  useEffect(() => {
    calcFCRPDPass()
  }, [allData]);

  return (
    <div className={styles.signup_info_wrapper}>
      <div className={styles.title}>报考信息</div>
      <div className={styles.signup_info_wrapper_body}>
        <img
          src={renderIcon(type === 'fcrpd' ? calcPaperState(signupInfoData, signupInfoData.paperState) : signupInfoData.state)}
          alt="" className={styles.img}/>
        {renderItem(type === 'fcrpd' ? calcPaperState(signupInfoData, signupInfoData.paperState) : signupInfoData.state)}
        {data.examExpiresTime && (
          <SignupInfoCountdown examExpiresTime={data.examExpiresTime}/>
        )}
      </div>
    </div>
  )
}
export default SignupInfo;
